// Constantes de la app agrupadas para poder tunearlas sin cazar magic numbers por el código.
// Las del router replican las del prototipo (`bus_elx_v2.html`) y son la referencia contra la
// que corren los tests de regresión: cambiarlas hará que los tests fallen y toque re-verificar.

import type { LatLng } from "./geo";

export const ELCHE_CENTER: LatLng = { lat: 38.2669, lon: -0.695 };
export const ELCHE_ZOOM = 14;
export const ELCHE_BOUNDS = { south: 38.23, west: -0.75, north: 38.31, east: -0.64 };

// Líneas de colores muy claros — se pintan con texto oscuro para conservar contraste cuando
// están activas. Sacado del prototipo original.
export const LIGHT_LINES = new Set([
  "K2", "I", "D", "L", "F",
  // Pedanías: dorado (el amarillo oficial se pierde sobre las carreteras del mapa).
  "R1", "R2", "R3", "R4", "R5", "R6", "R7", "R8", "R9", "R10", "R11", "R12",
]);

// Grupos de líneas que la app no enseña (ni consulta en tiempo real). Pedanías y cementerio
// quitados por ahora para pedir menos a la API; para volver a ponerlos, vaciar el conjunto.
export const HIDDEN_GROUPS: ReadonlySet<string> = new Set(["pedania", "cementerio"]);

// PRUEBA (2026-11-03): cartel encima de cada parada de las líneas activas con los segundos que
// faltan para la siguiente lectura del servidor; color según el próximo bus (verde, amarillo, rojo). Quitar (false)
// cuando acabe la prueba.
export const STOP_ETA_LABELS = true;

// Parámetros del planificador. Unidades:
//   walkSpeed → m/s (1.25 m/s = 4.5 km/h, ritmo normal)
//   walkDetour → factor de rodeo sobre la distancia en línea recta (calles urbanas ≈ 1.3)
//   busSpeed → m/s (4.2 m/s = 15.1 km/h, velocidad comercial estándar de bus urbano)
//   dwellSeconds → parada en cada intermedia (subida/bajada de pasajeros)
//   boardWaitSeconds → tiempo medio esperando el bus al subir (sin horarios reales)
//   maxWalkToStop → radio de captura de paradas candidatas alrededor de O/D
//   transferWalkMax → si dos paradas están más cerca que esto, permitimos trasbordo andando
export const ROUTER_CONFIG = Object.freeze({
  walkSpeed: 1.25,
  walkDetour: 1.3,
  busSpeed: 4.2,
  dwellSeconds: 20,
  boardWaitSeconds: 360,
  maxWalkToStop: 700,
  transferWalkMax: 180,
  minCandidateStops: 2,
  fallbackCandidateStops: 3,
});
export type RouterConfig = typeof ROUTER_CONFIG;
